import { Dropdown, Icon, message, Modal } from 'antd'
import React from 'react'
import AuthButton from '../../../components/AuthButton/AuthButton'
import { 
    fetchAccountingRecordClearConfirmation,  
    fetchAccountingRecordInitConfirmation, fetchAccountingRecordInitialProcess, 
    fetchAccountingRecordRevokeProcess, fetchAccountingRecordSponsorCloudLoansPayApplyFor, 
    fetchAccountingRecordSponsorOwnerRentApplyFor, fetchAccountingRecordSponsorPlatformOperateApplyFor 
} from '../../../services/accountingRecord'

/**
 * 列表流程操作按钮控制
 *
 * @class AccoungingRecordProcessActions
 * @extends {React.Component}
 */
class AccoungingRecordProcessActions extends React.Component{


    handleClick = (e) => {
        const key = e.target.getAttribute('data-key')
        this.showConfirm(key).then(() => {
            return this.strategyPost(key)
        }).then(() => {
            this.props.onChange && this.props.onChange()
        })
    }

    strategyPost(key) {
        switch (key) {
            case '清空汇集数据':  return this.postClearConfirmation()
            case '初始化汇集数据': return this.postInitConfirmation()
            case '发起流程': return this.postInitialProcess()
            case '撤回流程':return this.postRevokeProcess()
            case '发起云贷划账申请':return this.postSponsorCloudLoansPayApplyFor();
            case '发起业主租金划账申请': return this.postSponsorOwnerRentApplyFor();
            case '发起平台运营费用划账申请': return this.postPlatformOperateApplyFor();
            default: return Promise.resolve()
        }
    }

    showConfirm(title) {
        return new Promise((resolve,reject) => {
            Modal.confirm({
                title: '提示',
                content: '确认'+ title +'吗? ',
                onOk() {
                    resolve()
                },
                onCancel() {
                    reject()
                }
            })
        })
        
    }
    

    /** 
     * 清除对账确认书配置
     */ 
    postClearConfirmation() {
        const data = {accountingRecordLogId: this.props.records.id}
        return fetchAccountingRecordClearConfirmation(data).then(() => {
            message.success('操作成功')
        })
    }
    /**
     * 初始化对账确认书配置
     */
    postInitConfirmation() {
        const data = {accountingRecordLogId: this.props.records.id}
        return fetchAccountingRecordInitConfirmation(data).then(() => {
            message.success('操作成功')
        })
    }

    /**
     * 发起流程
     */
    postInitialProcess() {
        const data = {accountingRecordLogId: this.props.records.id}
        return fetchAccountingRecordInitialProcess(data).then(() => {
            message.success('操作成功')
        })
    }
    /**
     * 撤回流程
     */
    postRevokeProcess() {
        const data = {accountingRecordLogId: this.props.records.id}
        return fetchAccountingRecordRevokeProcess(data).then(() => {
            message.success('操作成功')
        })
    }

    


    /**
     * 商户对账单->发起云贷划账申请
     */
    postSponsorCloudLoansPayApplyFor() {
        const data = {accountingRecordLogId: this.props.records.id} 
        return fetchAccountingRecordSponsorCloudLoansPayApplyFor(data).then(() => {
            message.success('操作成功')
        })
    }

    /**
     * 商户对账单->发起业主租金划账申请
     */
    postSponsorOwnerRentApplyFor() {
        const data = {accountingRecordLogId: this.props.records.id} 
        return fetchAccountingRecordSponsorOwnerRentApplyFor(data).then(() => {
            message.success('操作成功')
        })
    }
    /**
     * 商户对账单->发起平台运营费用划账申请
     */
    postPlatformOperateApplyFor() {
        const data = {accountingRecordLogId: this.props.records.id} 
        return fetchAccountingRecordSponsorPlatformOperateApplyFor(data).then(() => {
            message.success('操作成功')
        })
    }
    

    


    render(){
        const menu = (records) => (
            <div onClick={this.handleClick} className="my-menu">
                { records.empty && (
                    <AuthButton authkey="e-11-4">
                        <div className="my-menu-item"  data-key="清空汇集数据">清空汇集数据</div>
                    </AuthButton>
                )}
                { records.initialize && (
                    <AuthButton authkey="e-11-5">
                        <div className="my-menu-item"  data-key="初始化汇集数据">初始化汇集数据</div>
                    </AuthButton>
                ) }
               
                { records.initiate && (
                    <AuthButton authkey="e-11-7">
                        <div className="my-menu-item"  data-key="发起流程">发起流程</div>
                    </AuthButton>
                ) }
                { records.recall && (
                    <AuthButton authkey="e-11-8">
                        <div className="my-menu-item"  data-key="撤回流程">撤回流程</div>
                    </AuthButton>
                ) }
              
                { records.sponsorCloudLoansPayApplyFor && (
                    <AuthButton authkey="e-11-9">
                        <div className="my-menu-item"  data-key="发起云贷划账申请">发起云贷划账申请</div>
                    </AuthButton>
                ) }
                { records.sponsorOwnerRentApplyFor && (
                    <AuthButton authkey="e-11-10">
                        <div className="my-menu-item" data-key="发起业主租金划账申请">发起业主租金划账申请</div>
                    </AuthButton>
                ) }
                { records.sponsorPlatformOperateApplyFor && (
                    <AuthButton authkey="e-11-11">
                        <div className="my-menu-item" data-key="发起平台运营费用划账申请">发起平台运营费用划账申请</div>
                    </AuthButton>
                ) }
            </div>
        )
        return (
            <div style={{display: 'inline-block'}}>
                 <Dropdown overlay={menu(this.props.records)} >
                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                        更多 <Icon type="down" />
                    </a>
                </Dropdown>
            </div>
            
        )
    }
}

export default AccoungingRecordProcessActions


// WEBPACK FOOTER //
// ./src/page/AccountingRecord/components/ProcessActions.jsx